import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FeaturesConfigModule } from '@spartacus/core';
import { BannerComponent, GenericLinkModule, MediaModule, ImageLoadingStrategy, ImageFetchPriority } from '@spartacus/storefront';
import { filter } from 'rxjs';

@Component({
  selector: 'app-custom-banner',
  standalone: true,
  imports: [CommonModule, GenericLinkModule, MediaModule, FeaturesConfigModule, RouterModule],
  templateUrl: './custom-banner.component.html',
})
export class CustomBannerComponent extends BannerComponent {
  router = inject(Router);
  ImageLoadingStrategy = ImageLoadingStrategy;
  ImageFetchPriority = ImageFetchPriority;

  ngOnInit() {
    let previousUrl = this.router?.url?.split('?')[0];

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const currentUrl = this.router.url?.split('?')[0];
        if (currentUrl !== previousUrl) {
          window.scrollTo({
            top: 0,
            behavior: 'instant',
          });
          previousUrl = currentUrl;
        }
      });
  }

  isHero(data: any): boolean {
    const url = data?.media?.url;
    return !!url && url.includes('bannerAM');
  }
}
